import { format24HourTime } from '../../../../../utils/supportHelpers';
import QuickActionCard from './QuickActionCard';

const MessageBubble = ({ message, guestName }) => {
  const isAgent = message.sender_type === 'agent';
  const isBot = message.sender_type === 'bot';

  if (isBot) {
    return (
      <div className="flex justify-center my-2">
        <span className="px-3 py-1 bg-teal-50/70 border border-teal-100 rounded-full text-[11px] text-[#067978] font-medium">
          💡 Guest requested: {message.text}
        </span>
      </div>
    );
  }

  return (
    <div className={`flex ${isAgent ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-[85%] md:max-w-[70%] flex flex-col ${isAgent ? 'items-end' : 'items-start'}`}>
        <div
          className={`p-3.5 rounded-2xl text-xs md:text-sm shadow-sm ${
            isAgent
              ? 'bg-[#067978] text-white rounded-br-none'
              : 'bg-white text-gray-900 border border-gray-200/80 rounded-bl-none'
          }`}
        >
          {message.attachment_url && (
            <img
              src={message.attachment_url}
              className="max-h-60 rounded-xl mb-2 object-cover border border-black/10 cursor-pointer"
              alt="Attachment"
              onClick={() => window.open(message.attachment_url, '_blank')}
            />
          )}

          {message.quick_action_data && (
            <QuickActionCard
              isAgent={isAgent}
              quickActionType={message.quick_action_type}
              quickActionData={message.quick_action_data}
            />
          )}

          <p className="leading-relaxed font-normal">{message.text}</p>
        </div>

        <span className="text-[10px] text-gray-400 mt-1 uppercase font-semibold tracking-tight">
          {isAgent ? 'You' : guestName || 'Traveller'} • {format24HourTime(message.timestamp || message.createdAt)}
        </span>
      </div>
    </div>
  );
};

export default MessageBubble;
